import { useState } from 'react';

import Button from '@mui/material/Button';
import styled from '@mui/material/styles/styled';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import AlertMessage from '../../elements/alert-message/AlertMessage';
import Text from '../../elements/text/Text';
import Modal from '../modal/Modal';
import ModalButtons from '../modal/ModalButtons';

const StyledSpan = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  borderBottom: 'solid 2px black',
}));

const DeleteButton = ({
  buttonText,
  buttonProps,
  description,
  onDelete,
  title,
  validation,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [form, setForm] = useState('');

  const handleFormChange = (e) => setForm(e.target.value);
  const toggleModal = () => {
    setOpen(!open);
    setForm('');
  };
  const handleDelete = async () => {
    await onDelete();
    toggleModal();
  };

  return (
    <>
      <Button color="error" onClick={toggleModal} {...buttonProps}>
        {buttonText || t('delete', { ns: 'buttons' })}
      </Button>
      <Modal
        openModal={open}
        title={title}
        action={
          <ModalButtons
            actionProps={{ disabled: form !== validation }}
            actionText={t('delete', { ns: 'buttons' })}
            cancelProps={{ type: 'reset' }}
            danger
            onAction={handleDelete}
            onCancel={toggleModal}
          />
        }
        handleClose={toggleModal}
      >
        <AlertMessage
          severity="error"
          message={t('cantUndo', { ns: 'descriptions' })}
          noPadding
        />
        <Text sx={{ mt: 2 }}>
          {description}{' '}
          <Trans
            i18nKey="deleteValidation"
            ns="descriptions"
            values={{ validation }}
            components={[<StyledSpan key="0" />]}
            shouldUnescape={true}
          />
        </Text>
        <TextField
          autoComplete="off"
          fullWidth
          label={t('deleteConfirm', { ns: 'fields' })}
          onChange={handleFormChange}
          size="small"
          slotProps={{
            htmlInput: {
              'aria-label': 'delete confirmation',
            },
          }}
          sx={{ mt: 3 }}
          value={form}
          variant="outlined"
        />
      </Modal>
    </>
  );
};

DeleteButton.propTypes = {
  buttonProps: PropTypes.object,
  buttonText: PropTypes.string,
  description: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  validation: PropTypes.string.isRequired,
};

export default DeleteButton;
